import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343550b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_2 = { class: "map-hotspots-container" }
const _hoisted_3 = { class: "player" }
const _hoisted_4 = { class: "spot" }

import { computed, onMounted, onUnmounted, ref } from 'vue';
import gsap from 'gsap'

import { Hotspot, useHotspots } from '@/services/stores/hotspots'
import { useGameState } from '@/services/composition';
import { playerScreenPosition } from '@/services/states/GameContextDatas'

import lerp from '@/utils/Lerp'

import MiniMapSVG from "@/assets/icons/mini-map.svg"
import MapHotspots from "./MapHotspots.vue";
import Viewport from '@/store/modules/Viewport';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { hotspots } = useHotspots()
const state = useGameState()

let rafId: number

const currentHotspots = computed(() => {
  return hotspots.filter(hotspot => hotspot.states.some(hState => state.value.matches(hState))) as Hotspot[]
})


// const playerTransform = computed(() => {
//   const pos = playerScreenPosition(state.value.context.position)
//   return { transform: `translate(${pos[0] * -220 + 120 * 0.5 - 22 * 0.5}px, ${pos[1] * -310 + 120 * 0.5 + 22 * 0.5}px)` }
// })

const playerRotate = computed(() => {
  const rotation = state.value.context.rotation
  return { transform: `rotate(${rotation - Math.PI}rad)` }
})

const playerPos = ref<{x: number, y: number}>({x: 0, y: 0})
const container = ref(null)
const update = () => {
  const pos = playerScreenPosition(state.value.context.position)
  playerPos.value.x = lerp(playerPos.value.x, (pos[0] * -220 + rootBCR.value.width * 0.5 - 22), 0.8)
  playerPos.value.y = lerp(playerPos.value.y, (pos[1] * -310 + rootBCR.value.width * 0.5 + 22 * 0.5), 0.8)

  const { x, y } = playerPos.value

  gsap.set(container.value, { x, y })

  rafId = requestAnimationFrame(update)
}

const resize = () => {
  rootBCR.value = root.value.getBoundingClientRect()
}

const root = ref(null)
const rootBCR = ref<DOMRect>(null)
onMounted(() => {
  if (Viewport.isMobile) {
    return
  }

  window.addEventListener('resize', resize)
  resize()
  rafId = requestAnimationFrame(update)
})

onUnmounted(()=> {
  window.removeEventListener('resize', resize)
  cancelAnimationFrame(rafId)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "mini-map",
        ref_key: "root",
        ref: root
      }, [
        _hoisted_1,
        _createElementVNode("div", {
          ref_key: "container",
          ref: container,
          class: "vector-container"
        }, [
          _createVNode(_unref(MiniMapSVG), { class: "mini-map-svg" }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(MapHotspots, { hotspots: _unref(currentHotspots) }, null, 8, ["hotspots"])
          ])
        ], 512),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "spot-fov",
              style: _normalizeStyle(_unref(playerRotate))
            }, null, 4)
          ])
        ])
      ], 512)
    ]),
    _: 1
  }))
}
}

})